import React, {Fragment, useState, useEffect} from 'react'
import {Button, Col, Row} from 'react-bootstrap'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import UserService from '../../../../../services/user'
import {toast} from 'react-toastify'
import FormGenerator from '../../../../../utils/helpers/FormGenerator'
import MasterServices from '../../../../../services/master'
import useDebounce from '../../../../../utils/hooks/useDebounce'

type Props = {
  onChange?: (e: any) => void
  toggle: () => void
  getData: any
  editFormValue?: any
  workingTypes: any
  industries: any
  companies: any
  companyOwnerships: any
}

const Forms: React.FC<Props> = ({
  toggle,
  getData,
  editFormValue,
  workingTypes,
  industries,
  companies,
  companyOwnerships,
}) => {
  const [submit, setSubmit] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [file, setFile] = useState<any>(null)
  const [formValue, setFormValue] = useState<any>({
    title: '',
    company_name: '',
    start_date: '',
    end_date: '',
    industries: '',
    description: '',
    company_ownerships_id: '',
  })

  const [inputs, setInputs] = useState<any>([
    {
      name: 'title',
      label: 'Posisi',
      type: '',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'working_type_id',
      label: 'Jenis Pekerjaan',
      type: 'select2',
      validation: {},
      col: 6,
      options: workingTypes || [],
      additional: '',
      getItemValue: 'working_types_name',
      getItemValueId: 'working_types_id',
    },
    {
      name: 'company_name',
      label: 'Nama Perusahaan',
      type: 'select-creatable',
      validation: {},
      col: 6,
      options: companies,
      additional: '',
      getItemValue: 'companies_name',
      getItemValueId: 'companies_id',
    },
    {
      name: 'company_ownerships_id',
      label: 'Kepemilikan',
      type: 'select2',
      validation: {},
      col: 6,
      disabled: false,
      options: companyOwnerships,
      additional: '',
      getItemValue: 'company_ownerships_name',
      getItemValueId: 'company_ownerships_id',
    },
    {
      name: 'start_date',
      label: 'Awal Bekerja',
      type: 'date',
      validation: {},
      col: 6,
      options: [],
      additional: '',
    },
    {
      name: 'end_date',
      label: 'Akhir Bekerja',
      type: 'date',
      validation: {},
      col: 6,
      disabled: false,
      options: [],
      additional: '',
      child: [
        {
          name: 'end_date_disabled',
          label: 'Saya masih bekerja dalam posisi ini',
          type: 'date',
          validation: {},
          col: 6,
          options: [],
          additional: '',
          counter: 1,
          child: [],
          getItemValue: null,
          items: [],
        },
      ],
    },
    {
      name: 'industries',
      label: 'Industri',
      type: 'select-creatable',
      validation: {},
      col: 12,
      options: industries || [],
      additional: '',
      getItemValue: 'industries_name',
      getItemValueId: 'industries_id',
    },
    {
      name: 'description',
      label: 'Deskripsi (Opsional)',
      type: 'textarea',
      validation: {},
      col: 12,
      options: [],
      additional: '',
    },
  ])

  useEffect(() => {
    let editRow = editFormValue
    editRow = {
      ...editFormValue,
      industries: editFormValue?.rowDetail?.industry?.industries_name,
      working_type_id: editFormValue?.rowDetail?.user_experiences_working_types_id,
    }
    setFormValue(editRow)
    if (!editFormValue.end_date) {
      disableUpload(!inputs[5].disabled)
    }

    if (editFormValue.company_ownerships_id) {
      inputs[3].disabled = true
      setInputs(inputs)
    }
  }, [editFormValue])

  useEffect(() => {
    let clone = inputs
    clone[1].items = workingTypes
    clone[1].options = workingTypes
    setInputs(clone)
  }, [workingTypes])

  useEffect(() => {
    let clone = inputs
    clone[2].items = companies
    clone[2].options = companies
    setInputs(clone)
  }, [companies])

  useEffect(() => {
    let clone = inputs
    clone[3].items = companyOwnerships
    clone[3].options = companyOwnerships
    setInputs(clone)
  }, [companyOwnerships])

  useEffect(() => {
    let clone = inputs
    clone[6].items = industries
    clone[6].options = industries
    setInputs(clone)
  }, [industries])

  useDebounce(
    () => {
      getIndustries()
      getCompanies()
      getCompanyOwnership()
    },
    250,
    [editFormValue]
  )

  const disableUpload = (value: boolean) => {
    let cloneForms = inputs
    cloneForms[5].disabled = value
    setInputs(cloneForms)
    setDisabled(value)
  }

  const onChange = (e: any) => {
    const {name, value} = e.target

    if (name === 'end_date_disabled') {
      setFormValue({
        ...formValue,
        end_date: null,
      })
      let cloneForms = inputs
      disableUpload(!cloneForms[5].disabled)
      return
    }

    if (name === 'company_name') {
      getCompanyByName({company_name: value.value})
      return
    }

    if (name === 'upload') {
      setFile(e.target.files[0])
      return
    }

    setFormValue({
      ...formValue,
      [name]: value,
    })
  }

  const onSelect = (input: any, row: any, key: any) => {
    const name = input
    switch (name) {
      case 'industries':
        getIndustries(row)
        break
      case 'company_name':
        getCompanies(row)
        break
    }
  }

  const uploadFile = async (id?: any) => {
    setSubmit(true)
    await UserService.uploadFileExperience({file}, id)
      .then(() => {
        toast.success(`Pengalaman Berhasil ${id ? 'Diperbarui' : 'Dibuat'}`)
        toggle()
        getData()
        setSubmit(false)
      })
      .catch((error) => {
        setSubmit(false)
      })
  }

  const handleSubmit = async (e: any) => {
    e?.preventDefault()
    const formData = new FormData(e.target)
    let formProps: any = Object.fromEntries(formData)

    formProps = {
      ...formProps,
      industries: parseInt(formProps.industries) || formProps.industries,
      company_ownership_id:
        formValue?.company_ownerships_id?.company_ownerships_id ?? formValue.company_ownerships_id,
    }

    setSubmit(true)

    await UserService.createOrUpdateExperience(
      formProps,
      editFormValue?.rowDetail?.user_experiences_id
    )
      .then((response) => {
        let id = editFormValue?.rowDetail?.user_experiences_id ?? response.data?.user_experiences_id
        if (file) {
          uploadFile(id)
          return
        }

        toast.success(
          `Pengalaman Berhasil ${
            editFormValue?.rowDetail?.user_experiences_id ? 'Diperbarui' : 'Dibuat'
          }`
        )
        toggle()
        getData()
        setSubmit(false)
      })
      .catch((error) => {
        setSubmit(false)
      })
  }

  const getIndustries = async (q = '') => {
    try {
      const {data} = await MasterServices.getIndustry({...{is_active: 1}, q})
      let clone = inputs
      clone[5].items = data.data
      clone[5].options = data.data
      setInputs(clone)
    } catch (error) {
    }
  }

  const getCompanies = async (q = '') => {
    try {
      const {data} = await MasterServices.getCompany({q})
      let clone = inputs
      clone[2].items = data.data
      clone[2].options = data.data
      setInputs(clone)
    } catch (error) {
    }
  }

  const getCompanyOwnership = async (q = '') => {
    try {
      const {data} = await MasterServices.getCompanyOwnership({...{is_active: 1}, q})
      let clone = inputs
      clone[3].items = data.data
      clone[3].options = data.data
    } catch (error) {
    }
  }

  const getCompanyByName = async (params?: any) => {
    try {
      const {data} = await MasterServices.getCompany({...params})

      let companyOwner = data.data[0]?.company_ownership ?? null
      let clone = inputs
      clone[3].disabled = companyOwner ? true : false
      setInputs(clone)

      setFormValue({
        ...formValue,
        company_ownerships_id: companyOwner,
        company_name: Object.values(params).toString(),
      })
    } catch (error) {
    }
  }

  return (
    <Fragment>
      <Form onSubmit={handleSubmit}>
        <Row>
          {FormGenerator(inputs, formValue, onChange, onSelect)}
          <Col md={12}>
            <Row className='d-grid gap-4'>
              <Col md={12}>
                <Form.Label>Unggah Dokumen Pendukung (Opsional)</Form.Label>
              </Col>
              <Col md={12}>
                <input type='file' name='upload' disabled={disabled} onChange={onChange} />
              </Col>
              {formValue?.rowDetail?.document_url_full && formValue?.rowDetail?.user_experiences_end_date ? (
                <Col md={12}>
                  <a href={formValue?.rowDetail?.document_url_full} target='_blank'>
                    Dokumen Pendukung
                  </a>
                </Col>
              ) : null}
              <Col md={12}>
                <Form.Text>pdf Max file size is 2MB</Form.Text>
              </Col>
            </Row>
          </Col>
        </Row>
        <Modal.Footer>
          <Button className='btn btn-secondary btn-sm' onClick={toggle} disabled={submit}>
            Batalkan
          </Button>
          <Button className='btn btn-primary btn-sm' type='submit' disabled={submit}>
            {submit ? 'Loading' : 'Simpan'}
          </Button>
        </Modal.Footer>
      </Form>
    </Fragment>
  )
}

export default Forms
